<template>
  <div id="trackinfo">
    <slot name="title-bar">
      <div class="title-bar">
        <h1><slot name="title">Default Title</slot></h1>
      </div>
    </slot>
    <slot name="header" />
    <div class="items-container">
      <div v-if="items && items.length > 0" class="items-list">
        <div
          v-for="(item, index) in items"
          :key="item.id"
          :class="{ 'even-background': index % 2 === 0 }"
        >
          <slot name="item" :item="item" :index="index" @remove-item="removeItem" />
        </div>
      </div>
      <div v-else class="no-items">{{ $t('noData') }}</div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { ref, onMounted, inject } from 'vue';
import { fetchList } from '../utils/api';

export default {
  name: 'GenericList',
  props: {
    apiEndpoint: {
      type: String,
      required: true,
    },
    data: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const items = ref([]);
    const apiBaseUrl = inject('apiBaseUrl');
    const { t } = useI18n();
    onMounted(async () => {
      if (props.data) {
        fetchList(t, `${apiBaseUrl}/list/${props.apiEndpoint}`, props.data).then((response) => {
          items.value = response.data.result;
          console.log(`${apiBaseUrl}/list/${props.apiEndpoint}`);
        });
      } else {
        fetchList(t, `${apiBaseUrl}/list/${props.apiEndpoint}`).then((response) => {
          items.value = response.data.result;
        });
      }
    });
    return {
      t,
      items,
    };
  },
  methods: {
    removeItem(itemToRemove) {
      const index = this.items.indexOf(itemToRemove);
      if (index > -1) {
        this.items.splice(index, 1);
      }
    },
    getItems() {
      return this.items;
    },
  },
};
</script>

<style>
.items-container {
  height: auto;
}
.items-list {
  padding-right: 10px;
}
.even-background {
  background-color: #eeeeee;
}
.no-items {
  text-align: center;
}
</style>
